module.exports = __webpack_public_path__ + "static/img/suidao.ba8467a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocbox/suidao.png
// module id = bSZp
// module chunks = 1